<template>
  <v-container class="mt-xs-8 mt-md-15 traffic-insurance mb-15">
    <v-row class="mr-0" justify="center">
      <h2 class="company-info--heading section-title-crosspage pl-1">
        {{ crossPageContent.mainTitle }}
      </h2>
    </v-row>
    <v-row class="mr-0 mt-14 align-center">
      <v-col
        ols="12"
        sm="7"
        md="5"
        lg="5"
        xl="5"
        class="offset-sm-3 offset-md-0"
      >
        <v-img
          min-height="150"
          max-height="600"
          width="100%"
          :src="getIllustrator"
          class="cross-info-image"
        ></v-img>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="7">
        <h3 class="traffic-insurance__heading">
          {{ crossPageContent.description.title }}
        </h3>
        <p
          class="traffic-insurance__text"
          v-for="parag in crossPageContent.description.content"
          :key="parag"
          v-html="parag"
        ></p>
        <h3 class="traffic-insurance__heading">
          {{ crossPageContent.subContent.title }}
        </h3>

        <div
          v-for="text in crossPageContent.subContent.content"
          :key="text.paragraph"
        >
          <p class="traffic-insurance__text" v-html="text.paragraph"></p>
          <ul v-if="text.subList">
            <li
              class="traffic-insurance__list-item"
              v-for="(sub, i) in text.subList"
              :key="i"
              v-html="sub"
            ></li>
          </ul>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    crossPageContent: {
      type: Object,
      require: true
    }
  },
  computed: {
    getIllustrator () {
      const routePath = this.$route.path.split('/')[2]
      return require(`@/assets/illustrations/${routePath}.svg`)
    }
  }
}
</script>

<style></style>
